import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {IconComponent} from '../../../../elements/icon/icon.component';
import {Icons} from '../../../../../model/icon';
import {NgForOf} from '@angular/common';
import {Card} from '../../../../../model/card';

@Component({
  selector: 'app-goal-section',
  imports: [
    IconComponent,
    NgForOf
  ],
  templateUrl: './goal-section.component.html',
  styleUrl: './goal-section.component.scss'
})
export class GoalSectionComponent implements OnInit {
  cards: Card[] = [
    {
      title: 'ПОЛУЧИТЬ ОПЫТ ПОД РУКОВОДСТВОМ ИНОСТРАННОГО СПЕЦИАЛИСТА',
      text : 'Уникальная возможность учиться у профессионалов мирового уровня, осваивать международные техники и подходы, чтобы вывести свою игру на новый уровень.',
      icon: Icons.inventory
    },
    {
      title: 'Отработать свои слабые и сильные стороны и перенять опыт профессионалов',
      text : 'Сосредоточьтесь на личном прогрессе: работайте над своими недостатками вместе с опытными игроками и тренерами, перенимая их знания и навыки.',
      icon: Icons.gate
    },
    {
      title: 'УЛУЧШИТЬ ФИЗИЧЕСКУЮ ФОРМУ И ВЫНОСЛИВОСТЬ',
      text : 'Подготовьте своё тело к серьёзным нагрузкам: станьте сильнее, быстрее и готовыми играть на максимуме в любой ситуации.',
      icon: Icons.strongerGold
    },
    {
      title: 'ПОЛУЧИТЬ ИНДИВИДУАЛЬНЫЕ РЕКОМЕНДАЦИИ ПО УЛУЧШЕНИЮ ИГРЫ',
      text : 'Работайте над собой с персональным подходом: получите конкретные советы от тренеров, чтобы устранить слабости и усилить свои сильные стороны.',
      icon: Icons.teachGold
    },
  ];
  firstArray: Card[] = [];
  secondArray: Card[] = [];

  ngOnInit() {
    this.splitArray();
  }

  splitArray() {
    const midIndex = Math.ceil(this.cards.length / 2);
    this.firstArray = this.cards.slice(0, midIndex);
    this.secondArray = this.cards.slice(midIndex);
  }

  protected readonly Icons = Icons;
}
